import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { healthProblemApi } from "../../../api/y-te/healthProblemApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eHealthProblemActionTypeIds,
	IHealthProblemDeleteStart,
	IHealthProblemLoadDangKyStart,
	IHealthProblemLoadDetailStart,
	IHealthProblemLoadStart,
	IHealthProblemSaveDangKyStart,
	IHealthProblemSaveStart
} from "../../action-types/y-te/IHealthProblemActionTypes";
import { healthProblemActions } from "../../actions/y-te/healthProblemActions";

export function* healthProblemSaga(): any {
	yield takeLatest(eHealthProblemActionTypeIds.LOAD_START, loadHealthProblemWorker)
	yield takeLatest(eHealthProblemActionTypeIds.LOAD_DETAIL_START, loadHealthProblemDetailWorker)
	yield takeLatest(eHealthProblemActionTypeIds.LOAD_DANGKY_START, loadHealthProblemDangKyWorker)
	yield takeEvery(eHealthProblemActionTypeIds.SAVE_START, saveHealthProblemWorker)
	yield takeEvery(eHealthProblemActionTypeIds.DELETE_START, deleteHealthProblemWorker)
	yield takeEvery(eHealthProblemActionTypeIds.SAVE_DANGKY_START, saveHealthProblemDangKyWorker)
}

function* loadHealthProblemWorker(action: IHealthProblemLoadStart): any {
	const res: IBaseResponeModel = yield call([healthProblemApi, healthProblemApi.SelectAllCheckDangKy], action.payload)
	if (res.is_success) {
		yield put(healthProblemActions.loadHealthProblemSuccess(res.data || []))
	} else {
		yield put(healthProblemActions.loadHealthProblemError(res.message || "Không tải được danh sách bệnh"))
	}
}

function* loadHealthProblemDetailWorker(action: IHealthProblemLoadDetailStart): any {
	const res: IBaseResponeModel = yield call([healthProblemApi, healthProblemApi.SelectById], action.payload)
	if (res.is_success) {
		if (res.data) {
			yield put(healthProblemActions.loadHealthProblemDetailSuccess(res.data))
		}
	} else {
		yield put(healthProblemActions.loadHealthProblemDetailError(res.message || "Không tải được chi tiết bệnh"))
	}
}

function* loadHealthProblemDangKyWorker(action: IHealthProblemLoadDangKyStart): any {
	const res: IBaseResponeModel = yield call([healthProblemApi, healthProblemApi.SelectAllCheckDangKy], action.payload)
	if (res.is_success) {
		yield put(healthProblemActions.loadHealthProblemDangKySuccess(res.data || []))
	} else {
		yield put(healthProblemActions.loadHealthProblemDangKyError(res.message || "Không tải được danh sách bệnh"))
	}
}

function* saveHealthProblemWorker(action: IHealthProblemSaveStart): any {
	let res: IBaseResponeModel;
	const is_update = action.payload.id > 0;
	if (is_update) {
		res = yield call([healthProblemApi, healthProblemApi.Update], action.payload);
	} else {
		res = yield call([healthProblemApi, healthProblemApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(healthProblemActions.saveHealthProblemSuccess(is_update))
	} else {
		yield put(healthProblemActions.saveHealthProblemError(res.message || "Không lưu được bệnh"))
	}
}

function* deleteHealthProblemWorker(action: IHealthProblemDeleteStart): any {
	const res: IBaseResponeModel = yield call([healthProblemApi, healthProblemApi.Delete], action.payload)
	if (res.is_success) {
		yield put(healthProblemActions.deleteHealthProblemSuccess())
	} else {
		yield put(healthProblemActions.deleteHealthProblemError(res.message || "Không xoá được bệnh"))
	}
}

function* saveHealthProblemDangKyWorker(action: IHealthProblemSaveDangKyStart): any {
	const res: IBaseResponeModel = yield call([healthProblemApi, healthProblemApi.InsertMultiple], action.payload)
	if (res.is_success) {
		yield put(healthProblemActions.saveHealthProblemDangKySuccess())
	} else {
		yield put(healthProblemActions.saveHealthProblemDangKyError(res.message || "Không lưu được đăng ký bệnh với cơ sở"))
	}
}
